// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"c6e0845b","239":"1d071ff5","453":"f88f8fbd","732":"128027a4","977":"b43d1f67"}[chunkId] + ".chunk.js";
};